define([
	"dojo/_base/declare",
	"csi/reflection",
	"csi/property/Widget"
], function(declare, reflection, Widget) {

	return declare(Widget, {
		postAction: function(/*Controller*/ac, /*Boolean*/bPendingAction) {
			// summary: update the whole view if we are changing a settings attribute
			if (!this.inherited(arguments)) {
				return false;
			}

			if (ac?.bDataChanged) {
				const node = ac.getNode();
				const rc = reflection.getNodeClass(node);
				if (rc?.isDerivedFrom("Configurable")) {
					node.Modified = true;
					this._redraw();
				}
			}

			return true;
		}
	});
});